import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"back"} maskId="square-filled-radius-0-stroke-1-IconBack"><path d="M5 4H6V20H5V4Z" fill="currentColor"/><path d="M19 4.07608V19.9239L6.87155 12L19 4.07608Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBack;
